import React from "react";
import { Brand } from "@/components/Brand";

/** Buy Me a Coffee (or similar) tip URL — build-time CRA env. Unset = page still works, no external CTA. */
const RAW_BMC_URL = (
  process.env.REACT_APP_BMC_URL ||
  process.env.REACT_APP_SUPPORT_URL ||
  ""
).trim();

function safeHttpUrl(url) {
  if (!url) return null;
  try {
    const u = new URL(url);
    if ((u.protocol !== "http:" && u.protocol !== "https:") || u.username || u.password) {
      return null;
    }
    return u.toString();
  } catch {
    return null;
  }
}

const BMC_URL = safeHttpUrl(RAW_BMC_URL);

/**
 * Quiet Support / Tip page. Optional tip keeps Trystomatic free — no modal spam.
 * External tip button only renders when REACT_APP_BMC_URL (or REACT_APP_SUPPORT_URL) is set.
 */
export function SupportPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="support-page">
      <header className="border-b border-[#0A0A0A]">
        <div className="max-w-3xl mx-auto px-6 lg:px-12 py-6 flex items-center justify-between gap-4">
          <a href="/" className="hover:opacity-80 transition-opacity" aria-label="TRYSTOMATIC home">
            <Brand size="md" />
          </a>
          <div className="flex items-center gap-4 text-xs uppercase tracking-[0.2em] font-mono-data text-[#52525B]">
            <a href="/about" className="hover:text-[#7C3AED] transition-colors">
              About
            </a>
            <a href="/" className="hover:text-[#7C3AED] transition-colors">
              Home
            </a>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 lg:px-12 py-12">
        <p className="label-eyebrow">Support</p>
        <h1 className="font-display font-black text-3xl sm:text-4xl tracking-tighter mt-1">
          Tip the project
        </h1>
        <p className="text-sm text-[#52525B] mt-3 max-w-prose leading-relaxed">
          TRYSTOMATIC stays free. An optional tip helps cover hosting and keep the tools running —
          no account required, no pressure.
        </p>

        <section className="mt-10 space-y-6 text-sm text-[#3F3F46] leading-relaxed">
          <p>
            Tips go through Buy Me a Coffee. Ads may also help when enabled; tips are a quieter way
            to support if you want to skip the ad side of things.
          </p>

          {BMC_URL ? (
            <p>
              <a
                href={BMC_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-[#0A0A0A] text-white px-5 py-3 text-xs uppercase tracking-widest font-semibold border border-[#0A0A0A] hover:bg-white hover:text-[#0A0A0A] transition-colors"
                data-testid="support-bmc-cta"
              >
                Buy Me a Coffee
              </a>
            </p>
          ) : (
            <p className="text-[#52525B] font-mono-data text-xs" data-testid="support-cta-pending">
              Tip link coming soon.
            </p>
          )}
        </section>
      </main>

      <footer className="border-t border-[#0A0A0A] mt-8">
        <div className="max-w-3xl mx-auto px-6 lg:px-12 py-8 text-xs text-[#52525B] font-mono-data flex flex-wrap items-center justify-between gap-2">
          <span>TRYSTOMATIC · Support · {new Date().getFullYear()}</span>
          <span className="flex items-center gap-3">
            <a href="/about" className="hover:text-[#7C3AED] transition-colors">
              About
            </a>
            <a href="/privacy" className="hover:text-[#7C3AED] transition-colors">
              Privacy
            </a>
          </span>
        </div>
      </footer>
    </div>
  );
}
